export default __webpack_public_path__ + "static/media/wild-plant.f47f8058.svg";